<template>
  <!-- footer -->
  <section class="footer">
    <footer>
      <div class="footer-main">
        <p class="ftlogo">
          <a href="https://www.lilithgames.com/en"
            ><img src="~images/logo.png"
          /></a>
        </p>
        <p>
          <a
            href="https://www.lilithgames.com/privacy?locale=en-US"
            target="_blank"
            alt="privacy policy"
            >PRIVACY POLICY</a
          ><span>|</span
          ><a
            href="https://www.lilithgames.com/termofservice?locale=en-US"
            target="_blank"
            alt="Terms of Service"
            >TERMS OF SERVICE</a
          >
        </p>
        <p>© 2022, LILITH GAMES - ALL RIGHTS RESERVED</p>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang='less'>
.footer {
  // position: absolute;
  // left: 0;
  // bottom: 0;
  width: 100%;
  // height: var(--footer-hegiht);
  padding-top: 20px;
  overflow: hidden;
  background: #222;
  color: #fff;

  footer {
    width: 80%;
    margin: 0 auto;
    // border-top: 1px solid #333;
    /* background:#000000; */
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: -moz-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -moz-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -moz-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;

    .footer-main {
      margin: 0 auto;
      font-size: 14px;
      color: #a9a9a9;
      text-align: center;

      > p {
        line-height: 50px;

        > a {
          margin: 0 10px;
          font-size: 14px;
          color: #e8e8e8;

          &:hover {
            color: #dc143c;
          }
        }
      }

      .lilith-game {
        position: absolute;
        display: block;
        width: 52px;
        height: 50px;
      }
    }
  }
}
</style>